var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/react-query";
/**
 * Fetches the identity provider environment from the API
 * @returns Promise resolving to identityAppEnv string
 */
const fetchIdpEnvironment = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === "undefined") {
        return undefined;
    }
    try {
        const response = yield fetch("/api/auth/idAppEnv");
        if (response.ok) {
            const data = (yield response.json());
            return data.identityAppEnv;
        }
        return undefined;
    }
    catch (_a) {
        // Silently fail - return undefined
        return undefined;
    }
});
/**
 * Hook to fetch the identity provider environment using React Query
 *
 * Uses React Query for:
 * - Automatic caching and deduplication
 * - Shared state across components
 * - Optimized refetching
 *
 * Query Key: ["identityAppEnvironment"] - shared with AppShellV2's useIdentityAppEnvironment
 *
 * @returns The identity provider environment string or undefined
 *
 */
export const useIdpEnvironment = () => {
    // Explicitly type Error for clarity and type safety, even though it's the default
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-arguments
    const { data: idpEnv } = useQuery({
        queryKey: ["identityAppEnvironment"],
        queryFn: fetchIdpEnvironment,
        staleTime: 10 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 2,
        retryDelay: 1000,
        enabled: typeof window !== "undefined",
    });
    return idpEnv;
};
